import { createFileRoute } from '@tanstack/react-router';
import { BroadcastsIndexRedirect } from '@/pages/workspaces/broadcasts/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/broadcasts/')({
  component: BroadcastsIndexRedirect,
});
